

<div class="geology">

  <ul class="nav nav-tabs not-selectable" >

    <li class="nav-item">
      <a class="nav-link " (click)="changerTab(1)" [ngClass]="tab() == 1 ? 'active':'' ">{{'GEOLOGY.DRILL_LOG' | translate }}</a>
    </li>
    <li class="nav-item" >
      <a class="nav-link" (click)="changerTab(2)" [ngClass]="tab() == 2 ? 'active':'' "> {{'GEOLOGY.HOLE_CONDITION' | translate }}</a>
    </li>
    <li class="nav-item" >
      <a class="nav-link" (click)="changerTab(3)" [ngClass]="tab() == 3 ? 'active':'' "> {{'GEOLOGY.LITHOLOGY' | translate }}</a>
    </li>
    <li class="nav-item" >
      <a class="nav-link" (click)="changerTab(4)" [ngClass]="tab() == 4 ? 'active':'' "> {{'GEOLOGY.MINERALISATION' | translate }}</a>
    </li>
  </ul>


  <div class="geology-type">
    @if (tab() === 1) {
      <app-drilllog-gui  [currentRegionId]="currentRegionId()" [isAdminOrResReg]="isAdminOrResReg()"></app-drilllog-gui>
    }
    @if (tab() === 2) {
      <app-hole-condition-gui  [currentRegionId]="currentRegionId()" [isAdminOrResReg]="isAdminOrResReg()"></app-hole-condition-gui>
    }
    @if (tab() === 3) {
      <app-litho-gui  [currentRegionId]="currentRegionId()" [isAdminOrResReg]="isAdminOrResReg()"></app-litho-gui>
    }
    @if (tab() === 4) {
      <app-mineralisation-gui  [currentRegionId]="currentRegionId()" [isAdminOrResReg]="isAdminOrResReg()"></app-mineralisation-gui>
    }
  </div>

</div>


